var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const SocialYoutubeIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsx(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: _jsx("path", { d: "M26.645 6.793C24.52 6.208 16 6.208 16 6.208s-8.52 0-10.645.585c-1.172.322-2.095 1.27-2.409 2.473C2.377 11.448 2.377 16 2.377 16s0 4.552.569 6.733c.313 1.204 1.237 2.152 2.409 2.474 2.125.585 10.645.585 10.645.585s8.52 0 10.645-.584c1.172-.322 2.096-1.27 2.409-2.474.569-2.182.569-6.734.569-6.734s0-4.552-.569-6.734c-.314-1.203-1.237-2.151-2.409-2.473M13.143 21.061V11.79l7.417 4.636z" }) })));
};
